export const selectFormValues = (state) => state.upsell.form;
export const selectPurchasedProducts = (state) =>
  state.upsell.form.purchasedProducts;
export const selectData = (state) => state.upsell.data;
export const selectLoading = (state) => state.upsell.loading;
export const selectError = (state) => state.upsell.error;
export const selectRestored = (state) => state.upsell.restored;
